import { useState, type TextareaHTMLAttributes, type CSSProperties, type FocusEvent } from "react";
import { useEmbedTokens } from "../theme";

interface Props extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "style"> { invalid?: boolean; }

export function EmbedTextarea({ invalid = false, disabled, onFocus, onBlur, ...rest }: Props) {
  const t = useEmbedTokens();
  const [focused, setFocused] = useState(false);
  const borderColor = invalid ? t.colors.error : focused ? t.colors.borderFocus : t.colors.border;
  const style: CSSProperties = {
    width: "100%", fontFamily: "inherit", fontSize: t.inputFontSize, color: t.colors.text,
    height: "auto", minHeight: 84, lineHeight: 1.5, padding: "10px 12px", resize: "vertical",
    borderRadius: t.borderRadius,
    background: disabled ? t.colors.disabledBg : t.colors.inputBg, border: `1px solid ${borderColor}`,
    outline: "none", boxShadow: focused && !invalid ? `0 0 0 3px ${t.colors.primaryTint}` : "none",
    transition: "border-color .12s, box-shadow .12s", boxSizing: "border-box",
  };
  return (
    <textarea {...rest} disabled={disabled} style={style}
      onFocus={(e: FocusEvent<HTMLTextAreaElement>) => { setFocused(true); onFocus?.(e); }}
      onBlur={(e: FocusEvent<HTMLTextAreaElement>) => { setFocused(false); onBlur?.(e); }} />
  );
}
